/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeAssets.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Asset Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 07:29:03 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const ASSET_LIST_CONTAINER_LOADED = 'ASSET_LIST_CONTAINER_LOADED';
export const ASSET_LIST_CONTAINER_UNLOADED = 'ASSET_LIST_CONTAINER_UNLOADED';
export const ASSET_LIST_TABLE_LOADED = 'ASSET_LIST_TABLE_LOADED';
export const ASSET_LIST_TABLE_UNLOADED = 'ASSET_LIST_TABLE_UNLOADED';

export const ASSET_LIST_CHANGE_GROUP = 'ASSET_LIST_CHANGE_GROUP';
export const ASSET_SELECT_ROW = 'ASSET_SELECT_ROW';

export const ASSET_ADD = 'ASSET_ADD';
export const ASSET_EDIT = 'ASSET_EDIT';
export const ASSET_DELETE = 'ASSET_DELETE';
export const ASSET_OPEN_WARNING = 'ASSET_OPEN_WARNING';
export const ASSET_CLOSE_WARNING = 'ASSET_CLOSE_WARNING';
export const ASSET_DELETE_DISABLE = 'ASSET_DELETE_DISABLE';
export const ASSET_VIEW_CHILD_ITEMS = 'ASSET_VIEW_CHILD_ITEMS';

export const ASSET_EDIT_CONTAINER_LOADED = 'ASSET_EDIT_CONTAINER_LOADED';
export const ASSET_EDIT_CONTAINER_UNLOADED = 'ASSET_EDIT_CONTAINER_UNLOADED';
export const ASSET_EDIT_FORM_LOADED = 'ASSET_EDIT_FORM_LOADED';
export const ASSET_EDIT_FORM_UNLOADED = 'ASSET_EDIT_FORM_UNLOADED';

export const ASSET_SET_GROUP_SELECT = 'ASSET_SET_GROUP_SELECT';
export const ASSET_LIST_COMPLETE = 'ASSET_LIST_COMPLETE';
export const ASSET_EDIT_DATA_LOAD = 'ASSET_EDIT_DATA_LOAD';

export const ASSET_EDIT_CONTAINER_SUBMIT = 'ASSET_EDIT_CONTAINER_SUBMIT';
export const ASSET_EDIT_CONTAINER_CANCEL = 'ASSET_EDIT_CONTAINER_CANCEL';

export const ASSET_UPDATE_VALUE = 'ASSET_UPDATE_VALUE';
export const ASSET_SELECT_INSPECTION_ROW = 'ASSET_SELECT_INSPECTION_ROW';

export const ASSET_LIST_HoseConditionStatus = 28;
export const ASSET_LIST_HoseDamage = 29;
export const ASSET_LIST_FittingDamage = 30;
export const ASSET_LIST_HoseMedia = 31;
export const ASSET_LIST_HoseType = 32;
export const ASSET_LIST_FittingTypes = 33;
export const ASSET_LIST_PressureRatingUnit = 34;
export const ASSET_LIST_LengthUnit = 35;
export const ASSET_LIST_SizeUnit = 36;
export const ASSET_LIST_Diameter = 37;
export const ASSET_LIST_HoseEndClockAngle = 38;
export const ASSET_LIST_FittingAngle = 39;
export const ASSET_LIST_FittingLength = 40;
export const ASSET_LIST_FittingGender = 41;
export const ASSET_LIST_Pulsation = 42;
export const ASSET_LIST_FluidChanges = 43;
export const ASSET_LIST_Rigs = 44;
export const ASSET_LIST_HoseManufacturer = 45;
export const ASSET_LIST_FittingMaterial = 46;
export const ASSET_LIST_FittingManufacturer = 47;
export const ASSET_LIST_EquipmentStatus = 48;
export const ASSET_LIST_EnvironmentalExposure = 49;



// WEBPACK FOOTER //
// ./src/constants/actionTypeAssets.js